// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@keller/App/Components/Common/XngZone";
import { DivWrapper } from "@keller/XDL/constants";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

interface DealerDetailsLayoutStyles {
    gridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    googleMapGridItem?: GridItemProps;
    infoWrapper?: InjectableCss;
}

const dealerDetailsLayoutStyles: DealerDetailsLayoutStyles = {
    gridContainer: {
        gap: 24,
    },
    infoGridItem: {
        width: [12, 12, 5, 5, 4],
    },
    googleMapGridItem: {
        width: [12, 12, 7, 7, 8],
    },
    infoWrapper: {
        css: css`
            width: 100%;

            & > ${DivWrapper} {
                &:not(:last-child) {
                    margin-bottom: 30px;
                }
            }

            ${({ isShellEditing }: any) =>
                !isShellEditing &&
                css`
                    & > ${DivWrapper} {
                        &:empty {
                            display: none;
                        }
                    }
                `}
        `,
    },
};

const styles = dealerDetailsLayoutStyles;
const DealerDetailsLayout: FC<Props> = ({ id }) => {
    const { isEditing } = useShellContext();

    return (
        <GridContainer {...styles.gridContainer} data-test-selector="DealerDetailsLayout">
            <GridItem {...styles.infoGridItem}>
                <StyledWrapper {...styles.infoWrapper} {...{ isShellEditing: isEditing }}>
                    <XngZone contentId={id} zoneName={translate("Location Info")} />
                    <XngZone contentId={id} zoneName={translate("ContactUs")} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.googleMapGridItem}>
                <XngZone contentId={id} zoneName={translate("Google Maps")} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: DealerDetailsLayout,
    definition: {
        group: "Dealer Details",
        allowedContexts: ["DealerDetailsPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
